import styled from "styled-components";

export const Wrapper = styled.div`
  z-index: ${({ theme }) => theme.zIndices.sticky};
  top: 70px;
  right: 0;
  left: 96px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 70px;
  padding: 0 20px;
  background-color: var(--white);
  border-bottom: 1px solid var(--border-shadow);

  > div {
    position: relative;
    display: flex;
    align-items: center;

    > * + * {
      margin-left: 10px;
    }
  }

  > div:first-child {
    flex-direction: column;
  }

  h2 {
    position: relative;
    display: inline-block;
    margin: 0;
    line-height: 1;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    top: 0;
    left: 0;

    &::before {
      right: -40px;
      left: -40px;
    }

    > div:first-child {
      flex-direction: row;
    }
  }
`;

export const WrapperWithBottomBar = styled.div`
  z-index: ${({ theme }) => theme.zIndices.sticky};
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  padding: 0 20px;
  background-color: var(--white);
  border-bottom: 1px solid var(--border-shadow);

  > div:first-child {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 70px;
  }

  > div:last-child {
    position: relative;
    display: flex;
    justify-content: flex-start;
    width: 100%;
    height: 46px;
  }

  > div:first-child > div {
    position: relative;
    display: flex;
    align-items: center;

    > * + * {
      margin-left: 10px;
    }
  }

  > div:first-child > div:first-child {
    flex-direction: column;
  }

  h2 {
    position: relative;
    display: inline-block;
    margin: 0;
    line-height: 1;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    top: 0;
    left: 0;

    &::before {
      right: -40px;
      left: -40px;
    }

    > div:first-child > div:first-child {
      flex-direction: row;
    }
  }
`;
